import React, { Component } from 'react';
import { Input, Button } from 'antd';

class AddItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemValue: ''
    };
    this.handleAddItem = this.handleAddItem.bind(this);
    this.handleAddItem = this.handleAddItem.bind(this);
  }

  handleAddItem() {
    if (this.state.itemValue.length) {
      this.props.handleAddItem(this.state.itemValue);
      this.setState({ itemValue: '' });
    }
  }
  handleChangeItemValue(e) {
    this.setState({ itemValue: e.target.value });
  }
  render() {
    const { handleCancelItem } = this.props;
    return (
      <div className="add-item">
        <Input
          autoFocus
          name="title"
          value={this.state.itemValue}
          onChange={e => this.handleChangeItemValue(e)}
          placeholder="enter text"
        />
        <div className="controls">
          <Button
            onClick={() => this.handleAddItem()}
            style={{ marginRight: 10 }}
            className="btn-save"
            size="small"
            type="primary"
          >
            Add
          </Button>
          <Button
            onClick={() => handleCancelItem()}
            ghost
            className="btn-cancel"
            size="small"
            type="primary"
          >
            Cancel
          </Button>
        </div>
      </div>
    );
  }
}
export default AddItem;
